import { Injectable } from '@angular/core';
import { QuantiteDossierPortefeuilleParProfileDTO } from '../model/quantite-dossier-portefeuille-par-profile-dto';
import { ChartViewDTO } from '../model/chart_view/chart-view-dto';
import { DurationByProduitDTO } from '../model/duration-by-produit-dto';
import { DurationByTaskDTO } from '../model/duration-by-task-dto';
import { SlaProduitDTO } from '../model/sla-produit-dto';
import { QuantiteDossierPortefeuilleParDepartementDTO } from '../model/quantite-dossier-portefeuille-par-departement-dto';
import { QuantiteDossierPortefeuilleParProduitDTO } from '../model/quantite-dossier-portefeuille-par-produit-dto';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { QuantiteDossierPortefeuilleParSecteurDTO } from '../model/quantite-dossier-portefeuille-par-secteur-dto.1';
import { TotalQuantiteMontantPourcentage } from '../model/quantite_montant_pourcentage/total-quantite-montant-pourcentage';

@Injectable({
    providedIn: 'root'
  })
export class DashboardAllMarcheService{
  
    constructor(private _restClientService : RestClientService) 
    {}
    
    rankingGestionnaireParMarche(workflow, agency, status) 
    {
        return this._restClientService.load<any[]>('dashboard-all-marche/ranking-gestionnaire-par-marche?workflow='+workflow+'&agency='+agency+'&status='+status);
    }
    
    portefeuilleTachesParMarche(workflow, agency) 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleParDepartementDTO[]>('dashboard-all-marche/portefeuille-taches-par-marche?workflow='+workflow+'&agency='+agency);
    }

    portefeuilleTachesParDepartement(workflow, agency, departement) 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleParProfileDTO[]>('dashboard-all-marche/portefeuille-taches-par-departement?workflow='+workflow+'&agency='+agency+'&departement='+departement);
    }

    slaPeriodeParProfile(workflow, agency) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-all-marche/sla-periode-par-profile?workflow='+workflow+'&agency='+agency);
    }
    
    //
    slaTacheParTypeCredit(workflow, agency) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-all-marche/sla-tache-par-type-credit?workflow='+workflow+'&agency='+agency);
    }

    durationTypeCredit(workflow, agency) 
    {
        return this._restClientService.load<DurationByProduitDTO[]>('dashboard-all-marche/duration-type-credit?workflow='+workflow+'&agency='+agency);
    }
    
    slaTypeCredit(workflow, agency) 
    {
        return this._restClientService.load<SlaProduitDTO[]>('dashboard-all-marche/sla-type-credit?workflow='+workflow+'&agency='+agency);
    }
    
    durationTaskByTypeCredit(codeTypeCredit) 
    {
        return this._restClientService.load<DurationByTaskDTO[]>('dashboard-all-marche/duration-task-by-type-credit?codeTypeCredit='+codeTypeCredit);
    }
    //

    
    //
    slaTacheParProduit(workflow, agency) 
    {
        return this._restClientService.load<ChartViewDTO>('dashboard-all-marche/sla-tache-par-produit?workflow='+workflow+'&agency='+agency);
    }

    durationProduit(workflow, agency) 
    {
        return this._restClientService.load<DurationByProduitDTO[]>('dashboard-all-marche/duration-produit?workflow='+workflow+'&agency='+agency);
    }
    
    slaProduit(workflow, agency) 
    {
        return this._restClientService.load<SlaProduitDTO[]>('dashboard-all-marche/sla-produit?workflow='+workflow+'&agency='+agency);
    }
    
    durationTaskByProduit(codeProduit) 
    {
        return this._restClientService.load<DurationByTaskDTO[]>('dashboard-all-marche/duration-task-by-produit?codeProduit='+codeProduit);
    }
    //
    
    
    quantiteDossierPortefeuilleParProduit(workflow, agency) 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleParProduitDTO[]>('dashboard-all-marche/quantite-dossier-portefeuille-par-produit?workflow='+workflow+'&agency='+agency);
    }



    quantiteDossierPortefeuilleParSecteur(workflow, agency) {
        return this._restClientService.load<QuantiteDossierPortefeuilleParSecteurDTO[]>('dashboard-all-marche/quantite-dossier-portefeuille-par-secteur?workflow=' + workflow + '&agency=' + agency);
    }

    
    quantiteDossierPortefeuilleParTypeCredit(workflow, agency) 
    {
        return this._restClientService.load<QuantiteDossierPortefeuilleParProduitDTO[]>('dashboard-all-marche/quantite-dossier-portefeuille-par-type-credit?workflow='+workflow+'&agency='+agency);
    }

    
    repartitionDossier12DerniersMoisParStatus(workflow) 
    {
        return this._restClientService.load<TotalQuantiteMontantPourcentage>('dashboard-all-marche/repartition-dossier-12-derniers-mois-par-status?workflow='+workflow);
    }

    
    
}